import { makeStyles } from '@material-ui/styles';

const toolStyles = makeStyles(theme => ({
  mainLink: {
    textDecoration: 'none'
  },
  root: {
    width: '100%',
    borderRadius: '12px',
    boxShadow: theme.shadows[4],
    backgroundColor: theme.palette.primary.white,
    [theme.breakpoints.down('sm')]: {
      marginBottom: '16px'
    }
  },
  toolsImg: {
    height: '40px',
    width: '40px',
    objectFit: 'contain'
  },
  cardInner: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '24px'
  },
  title: {},
  description: {},
  contentSection: {
    marginLeft: '14px',
    '& $title': {
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette.primary.black
    },
    '& $description': {
      color: theme.palette.primary.body,
      fontSize: '16px',
      marginTop: '6px'
    }
  },
}));

export default toolStyles;
